import gql from 'graphql-tag';

export const removeInspectionPhotoMutation = gql`
  mutation RemoveInspectionPhoto($input: RemoveInspectionPhotoInput!) {
    removeInspectionPhoto(input: $input) {
      success
      newVersion
    }
  }
`;
